module.exports = __webpack_public_path__ + "img/20180815_154807_253.b02f2157.jpg";